import WireframeWrapper from "./Wrapper";

export default {
  components: { WireframeWrapper },
  props: {
    bar: { default: () => ({}), type: Object },
    footer: { default: () => ({}), type: Object },
    forceCompactNavLeft: { default: false, type: Boolean },
    mobileBreakpoint: { default: "xs", type: [String, Number] },
    navLeft: { default: () => ({}), type: Object },
    navRight: { default: () => ({}), type: Object }
  },
  data() {
    const isMobileBreakpoint =
      typeof this.mobileBreakpoint === "number"
        ? this.$vuetify.breakpoint.width <= this.mobileBreakpoint
        : !!this.$vuetify.breakpoint[this.mobileBreakpoint];
    return {
      mobileMenuVisible: false,
      navLeftVisible: this.forceCompactNavLeft || !isMobileBreakpoint,
      navRightVisible: !isMobileBreakpoint
    };
  },
  computed: {
    navTogglerStyle() {
      return {
        height: `calc(calc(var(--vh, 1vh) * 100) - ${this.$vuetify.application.top}px)`,
        top: `${this.$vuetify.application.top}px`
      };
    }
  },
  watch: {
    forceCompactNavLeft: {
      immediate: true,
      handler(value) {
        if (value && !this.navLeftVisible) {
          this.navLeftVisible = true;
        }
      }
    },
    navLeftVisible(value) {
      if (this.forceCompactNavLeft && !value) {
        this.$nextTick(() => {
          this.navLeftVisible = true;
        });
      }
    }
  }
};
